import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom, type PropsOf } from '@blaze-runtime/engine-domain';
type IframeElement = CanvasElementFrom<'iframe'>;
type IframeProps = PartialDeep<PropsOf<'iframe'>>;

function transformTextInputToIframe(source: CanvasElementFrom<'textField'>): IframeElement {
  const props: PartialDeep<PropsOf<'textField'>> = source.props || {};

  const newProps: IframeProps = {
    content: {
      title: {
        align: props.content?.title?.align?.horizontal,
        enabled: props.content?.title?.enabled,
        icon: props.content?.title?.icon,
        iconPosition: props.content?.title?.iconPosition,
        label: props.content?.title?.label,
      },
    },
    style: {
      general: {
        // Text field external spacing (offset.margin since BL-10389) maps to iframe's inner
        // padding slot, matching the pre-migration behavior of copying offset verbatim
        offset: { padding: props.style?.general?.offset?.margin },
      },
      label: {
        color: props.style?.general?.title,
      },
      border: {
        outline: props.style?.input?.border,
        radius: props.style?.input?.radius,
      },
    },
  };

  return { props: newProps } as any;
}

export const transformToIframe = {
  transformTextInputToIframe,
};
